module.exports = __webpack_public_path__ + "static/img/AQ.a123705f.svg";